<template>
	<v-dialog v-model="visible" max-width="360">
		<v-card>
			<v-card-title class="headline">{{ commandName }}</v-card-title>
			<v-card-text>
				<v-form ref="form" lazy-validation @submit.prevent="close(true)">
					<k4-model-arg-form
						:args="argValues"
						:node="node"
						:subpath="subpath"
					>
						<template #empty> No command arguments required</template>
					</k4-model-arg-form>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn color="rust-red" text @click="close(false)">Cancel</v-btn>
				<v-btn color="ocean darken-1" outlined @click="close(true)"
					>Execute</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import _ from "lodash";

const initData = () => ({
	visible: false,
	loading: false,
	resolve: null,

	node: null,
	subpath: null,

	argValues: {},
});

export default {
	data: initData,

	computed: {
		commandName() {
			if (!this.subpath) return null;
			const commandName = _.last(this.subpath.split("/"));
			return _.startCase(commandName);
		},
	},

	watch: {
		visible(is, was) {
			// Reset all form data whenever dialog closes
			if (was && !is) this.reset();
		},
	},

	methods: {
		startCase: _.startCase,

		reset() {
			Object.assign(this, initData());
			this.$refs.form.resetValidation();
		},

		pop({ node, subpath }) {
			if (!node || !subpath) {
				console.error(
					"CommandArgsDialog requires both node and subpath arguments."
				);
				return;
			}

			this.node = node;
			this.subpath = subpath;
			this.visible = true;
			return new Promise(resolve => {
				this.resolve = resolve;
			});
		},

		async close(confirmed) {
			// User hit cancel
			if (!confirmed) {
				this.visible = false;
				if (this.resolve) this.resolve(false);
				return;
			}

			// Form has errors
			if (!this.$refs.form.validate()) return;

			// Everything is kosher
			try {
				if (this.resolve) await this.resolve(this.argValues);
			} finally {
				this.visible = false;
			}
		},
	},
};
</script>
